/**
 * Notification bell glyphs used by the sidebar's Patient Notifications entry.
 */

interface NotificationBellIconProps {
  className?: string;
}

/**
 * Outline bell icon for the inactive notifications tab.
 *
 * @param className - Optional class applied to the root `<svg>`
 * @returns An inline, currentColor-driven outline bell
 */
export function NotificationBellIcon({ className }: NotificationBellIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.73 21a2 2 0 0 1-3.46 0"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Filled bell icon for the active notifications tab. Same geometry as
 * {@link NotificationBellIcon}, with the body and clapper filled.
 *
 * @param className - Optional class applied to the root `<svg>`
 * @returns An inline, currentColor-driven filled bell
 */
export function NotificationBellIconFilled({ className }: NotificationBellIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.73 21a2 2 0 0 1-3.46 0"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NotificationBellIcon;
